export default {"src":"/newStatic/_next/static/media/pattern-4.ae149144.svg","height":50,"width":768};